import { useGetUserStatusSuspense } from "api/generated/utils/utils";

const AVAILABLE_ACTIONS_TIMEOUT_MILLI = 60000;

export const useUserStatusQuery = () => {
    return useGetUserStatusSuspense({
        query: {
            select: (response) => response.data,
            staleTime: AVAILABLE_ACTIONS_TIMEOUT_MILLI,
            refetchInterval: AVAILABLE_ACTIONS_TIMEOUT_MILLI,
            retry: true,
            refetchOnWindowFocus: true,
        },
    });
};
